import { NgModule } from '@angular/core'

// Layout PrimeNG modules
import { DrawerModule } from 'primeng/drawer'
import { TabsModule } from 'primeng/tabs'
import { AccordionModule } from 'primeng/accordion'
import { ScrollPanelModule } from 'primeng/scrollpanel'
import { SplitButtonModule } from 'primeng/splitbutton'
import { StepsModule } from 'primeng/steps'

/**
 * Layout PrimeNG module for navigation and layout components.
 * Import this only in modules that need layout functionality.
 */
@NgModule({
  exports: [DrawerModule, TabsModule, AccordionModule, ScrollPanelModule, SplitButtonModule, StepsModule],
})
export class LayoutPrimeNGModule {}
